export default __webpack_public_path__ + "static/media/angular.be2aa759.png";